// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__fK4dG","breadcrumb_item":"Breadcrumb_breadcrumb_item__t3irT"};